export default {
    productionSites: [],
    productionSitesLoading: false,
}
